<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content>
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Services</h1>
      </base-content>
    </div>
    <base-content>
      <base-list-group listType="unordered">
        <base-list-item v-for="service in services" :key="service.title">
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex-col">
              <div class="tw-text-gray-800 tw-font-normal tw-text-base">{{ service.title }}</div>
              <div class="tw-text-sm tw-text-gray-500 tw-font-thin">{{ service.description }}</div>
            </div>
            <base-button class="tw-my-auto tw-ml-10" @click="invokeService(service)" :loading="service.isLoading">
              Run
            </base-button>
          </div>
        </base-list-item>
        <base-list-item>
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex-col">
              <div class="tw-text-gray-800 tw-font-normal tw-text-base">Save Rx Details PDF</div>
              <div class="tw-text-sm tw-text-gray-500 tw-font-thin">Requests a new Rx Details PDF to be generated for a partiular patient.</div>
            </div>
            <base-button class="tw-my-auto tw-ml-10" @click="rxDetailPDFModal">
              Run
            </base-button>
          </div>
        </base-list-item>
        <base-list-item>
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex-col">
              <div class="tw-text-gray-800 tw-font-normal tw-text-base">Fire Error</div>
              <div class="tw-text-sm tw-text-gray-500 tw-font-thin">Fires a fake error to test the error event capability and display messages.</div>
            </div>
            <base-button class="tw-my-auto tw-ml-10" @click="error">
              Run
            </base-button>
          </div>
        </base-list-item>
      </base-list-group>
      <base-card v-if="responses.length > 0" class="tw-mt-6 tw-bg-gray-200 tw-h-96 tw-overflow-y-scroll">
        <div class="tw-mb-4">Response</div>
        <div class="tw-text-xs">
          <div v-for="(responseObj, index) in responses" :key="index">
            <pre>{{ prettifyJSON(responseObj) }}</pre>
          </div>
        </div>
      </base-card>
    </base-content>
    <RxDetailsPDFInput ref="rxDetailsPDFModal" />
  </div>
</template>

<script>
import RxDetailsPDFInput from "@/views/admin/services/components/RxDetailsPDFInput";

export default {
  components: {
    RxDetailsPDFInput,
  },
  data() {
    return {
      archiveCompletedActivitiesLoading: false,
      syncChargesLoading: false,
      deleteCancelledPlansLoading: false,
      deleteAwaitingPaymentPlansLoading: false,
      emailLocationsLoading: false,
      getSubscriptionReconciliationLoading: false,
      backfillTodoAssignedDateLoading: false,
      hydrateMemberSearchLoading: false,
      savePDFLoading: false,
      scaleRdsLoading: false,
      zapierChargesLoading: false,
      zapierPlansLoading: false,
      zapierPrescriptionsLoading: false,
      zapierRefundsLoading: false,
      responses: [],
    };
  },
  computed: {
    services() {
      return [
        {
          title: "Hydrate Member Search Cache",
          verb: "post",
          description: "Collects all members and hydrates the search cache.",
          endpoint: "/services/hydrate-member-search-cache",
          isLoading: this.hydrateMemberSearchLoading,
          loadingKey: "hydrateMemberSearchLoading",
        },
        {
          title: "Archive Completed Activities",
          verb: "post",
          description: "Archives completes activities that are more than 30 days completed.",
          endpoint: "/services/archive-completed-todo",
          isLoading: this.archiveCompletedActivitiesLoading,
          loadingKey: "archiveCompletedActivitiesLoading",
        },
        {
          title: "Backfill Todo AssignedDate",
          verb: "post",
          description: "Backfills the assigned date for all todos that are missing it.",
          endpoint: "/services/backfill-todo-assigned-date",
          isLoading: this.backfillTodoAssignedDateLoading,
          loadingKey: "backfillTodoAssignedDateLoading",
        },
        {
          title: "Get Subscription reconciliation",
          verb: "post",
          description: "Gets a mapping of all Stripe subscriptions linked to plans and shows any subscriptions not linked.",
          endpoint: "/services/get-subscriptions-reconcile",
          isLoading: this.getSubscriptionReconciliationLoading,
          loadingKey: "getSubscriptionReconciliationLoading",
        },
        {
          title: "Sync Charges",
          verb: "post",
          description: "Retrieves a list of all historic charges from Stripe for the business and adds/updates them in the platform database.",
          endpoint: "/services/sync-charges",
          isLoading: this.syncChargesLoading,
          loadingKey: "syncChargesLoading",
        },
        {
          title: "Delete Cancelled Plans",
          verb: "post",
          description: "Loops through all canceled plans and deletes them if they are past the time threshold.",
          endpoint: "/services/delete-cancelled-plans",
          isLoading: this.deleteCancelledPlansLoading,
          loadingKey: "deleteCancelledPlansLoading",
        },
        {
          title: "Delete Awaiting Payment Plans",
          verb: "post",
          description: "Loops through all plans that are awaiting payment and deletes them if they are past the time threshold.",
          endpoint: "/services/delete-awaiting-payment-plans",
          isLoading: this.deleteAwaitingPaymentPlansLoading,
          loadingKey: "deleteAwaitingPaymentPlansLoading",
        },
        {
          title: "Email Locations for Rx Contact Attempted",
          verb: "post",
          description: "Runs the job to email a reminder to all locations for prescriptions waiting in Contact Attempted status.",
          endpoint: "/services/rx-email-location-contact-attempted",
          isLoading: this.emailLocationsLoading,
          loadingKey: "emailLocationsLoading",
        },
        {
          title: "Scale RDS to desired capacity (peak / off-peak)",
          verb: "post",
          description: "Executes the job to scale RDS up or down depending on the time of day.",
          endpoint: "/services/scale-rds",
          isLoading: this.scaleRdsLoading,
          loadingKey: "scaleRdsLoading",
        },
        {
          title: "Zapier Charges - Get list of platform events",
          verb: "get",
          description: "Gets the list of platform events for recent charges",
          endpoint: "/zapier/charges",
          isLoading: this.zapierChargesLoading,
          loadingKey: "zapierChargesLoading",
        },
        {
          title: "Zapier Refunds - Get list of platform events",
          verb: "get",
          description: "Gets the list of platform events for recent refunds",
          endpoint: "/zapier/refunds",
          isLoading: this.zapierRefundsLoading,
          loadingKey: "zapierRefundsLoading",
        },
        {
          title: "Zapier Plans - Get list of platform events",
          verb: "get",
          description: "Gets the list of platform events for recent member plans",
          endpoint: "/zapier/new-plans",
          isLoading: this.zapierPlansLoading,
          loadingKey: "zapierPlansLoading",
        },
        {
          title: "Zapier Prescriptions - Get list of platform events",
          verb: "get",
          description: "Gets the list of platform events for recent prescriptions",
          endpoint: "/zapier/new-prescriptions",
          isLoading: this.zapierPrescriptionsLoading,
          loadingKey: "zapierPrescriptionsLoading",
        },
      ];
    },
  },
  methods: {
    async invokeService(service) {
      try {
        this.responses = [];
        this[service.loadingKey] = true;

        if (service.verb === "get") {
          await this.$axios.get(service.endpoint).then((res) => {
            this.responses = res.data;
          });
        } else if (service.verb === "post") {
          await this.$axios.post(service.endpoint);
        }
      } finally {
        this[service.loadingKey] = false;
      }
    },
    error() {
      this.EventBus.$emit("GLOBAL_ERROR", {
        title: "We had an issue fulfilling your request.",
        message: "We tried to connect to the server but we could not find it. You might want to try again.",
        error: { message: "404 server not found" },
      });
    },
    rxDetailPDFModal() {
      this.$refs.rxDetailsPDFModal.show();
    },
    prettifyJSON(object) {
      return JSON.stringify(object, null, 4);
    },
  },
};
</script>
